import * as React from "react"

const Spacer = ({ height }) => {
    return (<div style={{ height: parseInt(height) }}></div >)
}

export default Spacer